import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { CommercialCardImageWidth, } from '../../../../../../components/commercialCard/types/commercialCardTheme';
export const horizontalCommonStyles = (FOUNDATIONS, FONT) => ({
    showToggle: true,
    showButton: false,
    showContentSlot: false,
    container: {
        display: 'flex',
        position: 'relative',
        overflow: 'hidden',
        border_radius: FOUNDATIONS.radius_comp_commercial_commercialcard_containerradius,
        flex_direction: 'row',
        padding: FOUNDATIONS.spacing_100,
        background_color: FOUNDATIONS.color_neutral_bg_onsurface_100,
        width: '100%',
    },
    imageContainer: {
        width: FOUNDATIONS.size_1110,
        [DeviceBreakpointsType.MOBILE]: { width: FOUNDATIONS.size_650 },
        border_top_left_radius: FOUNDATIONS.radius_comp_commercial_commercialcard_image_radiussize,
        border_bottom_left_radius: FOUNDATIONS.radius_comp_commercial_commercialcard_image_radiussize,
        flex_shrink: '0',
        [CommercialCardImageWidth.SHORT]: {
            width: FOUNDATIONS.size_650,
        },
        [CommercialCardImageWidth.LONG]: {
            width: FOUNDATIONS.size_1110,
        },
    },
    contentContainer: {
        // padding applied to text content (middle) and toggle (right)
        padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_200}`,
        align_items: 'center',
    },
    toggleContainer: {
        margin_left: FOUNDATIONS.spacing_150,
    },
});
//# sourceMappingURL=horizontalCommon.js.map